import { render, staticRenderFns } from "./NewBarChart.vue?vue&type=template&id=0f9c83b2"
import script from "./NewBarChart.vue?vue&type=script&lang=js"
export * from "./NewBarChart.vue?vue&type=script&lang=js"
import style0 from "./NewBarChart.vue?vue&type=style&index=0&id=0f9c83b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports